import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EoHttpClient, IHttpParams } from '../../common/eo-http-client.service';
import { STATUS } from '../../common/use-loading.model';

@Injectable({
  providedIn: 'root',
})
export class EoDropdownService<T> {
  data$ = new BehaviorSubject<T[] | null>([]);
  status$ = new BehaviorSubject<STATUS>(STATUS.pending);
  error$ = new BehaviorSubject<string | null>(null);

  constructor(
    @Inject('apiUrl') private readonly apiUrl: string,
    private http: EoHttpClient
  ) {}

  init() {
    this.data$.next(null);
    this.status$.next(STATUS.pending);
    this.error$.next(null);
  }

  getData(url: string): Observable<T[]> {
    const param: IHttpParams = {
      url: `${this.apiUrl}/${url}`,
      success$: this.data$,
      status$: this.status$,
      error$: this.error$,
    };

    return this.http.get<T[]>(param);
  }

  getFilteredData(url: string, term: string): Observable<T[]> {
    const param: IHttpParams = {
      url: `${this.apiUrl}/${url}/${term}`,
      success$: this.data$,
      status$: this.status$,
      error$: this.error$,
    };

    return this.http.get<T[]>(param);
  }
}
